import React from "react";
import Grid from "@material-ui/core/Grid";

interface Props {
  children?: React.ReactNode;
}

function RowRight(props: Props) {
  return (
    <Grid item xs={4} sm={3} lg={3}>
      {props.children}
    </Grid>
  );
}

export default RowRight;
